import styled from 'styled-components';
import { colors } from 'bench-style-constants';

export const Header = styled.div`
  background: ${colors.pearl};
  border-bottom: 1px solid ${colors.silt};
  grid-area: header;
  // Technically this should be "overflow: auto;" so that the content can be scrolled horizontally
  // when it overflows, but since the year-month picker dropdown is implemented as a nested element
  // instead of being mounted at the body it would be cut off
  overflow: visible;
  position: relative;
  z-index: 2;
`;
